import React from 'react'
import { Input, Label, FormGroup } from 'reactstrap'

export interface CustomInputProps {
    type?: 'switch' | 'checkbox' | 'radio' | string;
    id?: string;
    name?: string;
    label?: React.ReactNode;
    inline?: boolean;
    invalid?: boolean;
    className?: string;
    children?: React.ReactNode;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: (e: React.MouseEvent) => void;
    value?: any;
    [key: string]: any;
}

const CustomInput = React.forwardRef<any, CustomInputProps>(({
    type,
    id,
    name,
    label,
    inline,
    invalid,
    className,
    children,
    ...rest
}, ref) => {
    const isSwitch = type === 'switch'

    const inputProps: any = {
        type: isSwitch ? 'switch' : type,
        id,
        name,
        invalid,
        ...rest
    }

    if (isSwitch) {
        return (
            <FormGroup switch inline={inline} className={className}>
                <Input {...inputProps} ref={ref} role="switch" />
                {label && <Label check htmlFor={id}>{label}</Label>}
                {children}
            </FormGroup>
        )
    }

    // checkbox or radio
    return (
        <FormGroup check inline={inline} className={className}>
            <Input {...inputProps} ref={ref} />
            {label && <Label check htmlFor={id}>{label}</Label>}
            {children}
        </FormGroup>
    )
})

CustomInput.displayName = 'CustomInput'

export default CustomInput
